import React from 'react';
import Badge from '@cloudscape-design/components/badge';

/**
 * Small visual marker for events produced by a Bedrock inference rule.
 * Rendered next to EventTypeIndicator in the Events table, Tree view,
 * Compact view, and EventDetailPanel header. Consumers of this component
 * are responsible for checking isBedrockEvent(item) before rendering.
 */
export function AiBadge() {
  return (
    <span
      style={{ marginLeft: 6, verticalAlign: 'middle' }}
      title="Produced by Bedrock inference rule"
      aria-label="AI-generated"
    >
      <Badge color="blue">AI</Badge>
    </span>
  );
}
